// src/services/documents.ts
import api, { webApi, getCsrfToken } from "../api";

export function getDocuments() {
  return api.get("/documents");
}

export async function uploadDocument(formData: FormData) {
  await getCsrfToken();
  return webApi.post(`/admin/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function deleteDocument(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/documents/${id}`);
}
